import React, { createContext, useState, useEffect } from "react";
import { getDischargedPatients } from "../services/getDischargedPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const DischargedContext = createContext();

export const DischargedProvider = ({ children }) => {
  const [dischargedPatients, setDischargedPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState(null);

  const { token, isValid, authLoading } = useValidToken();

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);
      try {
        const data = await getDischargedPatients(null, locationId);
        setDischargedPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, locationId]);

  return (
    <DischargedContext.Provider
      value={{
        dischargedPatients,
        loading,
        error,
        setLocationId
      }}
    >
      {children}
    </DischargedContext.Provider>
  );
};
